export default __webpack_public_path__ + "22232f943c4d1a4bfd6df5daff046c28.png";